import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import saveToMyAccount from '../../actions/saveToMyAccount';
import SaveIconButton from './SaveIconButton';

const mapStateToProps = ({ estimateBuilder }) => ({
  designId: estimateBuilder.uiState.selectedEstimate,
  isLinked:
    estimateBuilder.entities.estimates.byId[estimateBuilder.uiState.selectedEstimate].isLinked,
});

const mapDispatchToProps = dispatch => bindActionCreators({ saveToMyAccount }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaveIconButton);
